import React from "react";
import Header from "../component/Header";
import { Link } from "react-router-dom";

const SpinWeb = () => {
  return (
    <>
      <Header />
      <div className="body">
        <div data-v-bc96a3bc>
          <div data-v-bc96a3bc className="roulette luckywheel luckywheel-bg">
            <div data-v-bc96a3bc className="rouletteMain">
              <div data-v-bc96a3bc className="rouletteMain_wrap">
                <ul data-v-bc96a3bc className="rouletteMain_head">
                  <li
                    data-v-bc96a3bc
                    className="rouletteMain_item"
                    style={{ "list-style-type": "none" }}
                  >
                    <Link data-v-bc96a3bc to="/" className="active">
                      Home
                    </Link>
                  </li>
                </ul>
                <div data-v-bc96a3bc className="rouletteMain_body">
                  <ul
                    data-v-bc96a3bc
                    className="rouletteMain_awards"
                    style={{ "list-style-type": "none", height: "1000px" }}
                  >
                    <li data-v-bc96a3bc className="rouletteMain_awards_item">
                      <div data-v-bc96a3bc>
                        <div
                          data-v-bc96a3bc
                          className="rouletteMain_awards_medals"
                        />
                        <div
                          data-v-bc96a3bc
                          className="rouletteMain_awards_prize"
                        >
                          <img
                            data-v-bc96a3bc
                            src="/assets/new/668b59dd38222.webp"
                          />
                        </div>
                        <div
                          data-v-bc96a3bc
                          className="rouletteMain_awards_text"
                        >
                          ৳22
                        </div>
                      </div>
                    </li>
                    <li data-v-bc96a3bc className="rouletteMain_awards_item">
                      <div data-v-bc96a3bc>
                        <div
                          data-v-bc96a3bc
                          className="rouletteMain_awards_medals"
                        />
                        <div
                          data-v-bc96a3bc
                          className="rouletteMain_awards_prize"
                        >
                          <img
                            data-v-bc96a3bc
                            src="/assets/new/668b59dd38233.webp"
                          />
                        </div>
                        <div
                          data-v-bc96a3bc
                          className="rouletteMain_awards_text"
                        >
                          ৳33
                        </div>
                      </div>
                    </li>
                    <li data-v-bc96a3bc className="rouletteMain_awards_item">
                      <div data-v-bc96a3bc>
                        <div
                          data-v-bc96a3bc
                          className="rouletteMain_awards_medals"
                        />
                        <div
                          data-v-bc96a3bc
                          className="rouletteMain_awards_prize"
                        >
                          <img
                            data-v-bc96a3bc
                            src="/assets/new/668b59dd38243.webp"
                          />
                        </div>
                        <div
                          data-v-bc96a3bc
                          className="rouletteMain_awards_text"
                        >
                          ৳88
                        </div>
                      </div>
                    </li>
                    <li data-v-bc96a3bc className="rouletteMain_awards_item">
                      <div data-v-bc96a3bc>
                        <div
                          data-v-bc96a3bc
                          className="rouletteMain_awards_medals"
                        />
                        <div
                          data-v-bc96a3bc
                          className="rouletteMain_awards_prize"
                        >
                          <img
                            data-v-bc96a3bc
                            src="/assets/new/668b59dd38277.webp"
                          />
                        </div>
                        <div
                          data-v-bc96a3bc
                          className="rouletteMain_awards_text"
                        >
                          ৳222
                        </div>
                      </div>
                    </li>
                    <li data-v-bc96a3bc className="rouletteMain_awards_item">
                      <div data-v-bc96a3bc>
                        <div
                          data-v-bc96a3bc
                          className="rouletteMain_awards_medals"
                        />
                        <div
                          data-v-bc96a3bc
                          className="rouletteMain_awards_prize"
                        >
                          <img
                            data-v-bc96a3bc
                            src="/assets/new/668b59dd38666.webp"
                          />
                        </div>
                        <div
                          data-v-bc96a3bc
                          className="rouletteMain_awards_text"
                        >
                          ৳666
                        </div>
                      </div>
                    </li>

                    <li data-v-bc96a3bc className="rouletteMain_awards_item">
                      <div data-v-bc96a3bc>
                        <div
                          data-v-bc96a3bc
                          className="rouletteMain_awards_medals"
                        />
                        <div
                          data-v-bc96a3bc
                          className="rouletteMain_awards_prize"
                        >
                          <img
                            data-v-bc96a3bc
                            src="/assets/new/668b59dd38201.webp"
                          />
                        </div>
                        <div
                          data-v-bc96a3bc
                          className="rouletteMain_awards_text"
                        >
                          ৳1111
                        </div>
                      </div>
                    </li>
                  </ul>
                  <div data-v-bc96a3bc className="roulette-period">
                    2024-09-05 - 2030-12-31
                  </div>
                  <div data-v-bc96a3bc className="rouletteMain_box">
                    <div
                      data-v-bc96a3bc
                      className="roulette_main_numberTimes_left"
                    >
                      <div data-v-bc96a3bc>
                        <div data-v-bc96a3bc>
                          <span
                            data-v-bc96a3bc
                            className="font-weight-bold title"
                          >
                            20
                          </span>
                          <span data-v-bc96a3bc> coins</span>
                          <br data-v-bc96a3bc />
                          /swing
                        </div>
                      </div>
                    </div>
                    <div
                      data-v-bc96a3bc
                      className="rouletteMain_box_wrap rouletteMain_P8_N8 luckywheel"
                    >
                      <ul
                        data-v-bc96a3bc
                        className="rouletteMain_box_part rouletteMain_box_part-8 luckywheel"
                      >
                        <li
                          data-v-bc96a3bc
                          className="rouletteMain_box_part_list"
                        >
                          <div
                            data-v-bc96a3bc
                            className="rouletteMain_box_part_color"
                          />
                          <span
                            data-v-bc96a3bc
                            className="rouletteMain_box_part_award"
                          >
                            ৳11
                          </span>
                        </li>
                        <li
                          data-v-bc96a3bc
                          className="rouletteMain_box_part_list"
                        >
                          <div
                            data-v-bc96a3bc
                            className="rouletteMain_box_part_color"
                          />
                          <span
                            data-v-bc96a3bc
                            className="rouletteMain_box_part_award"
                          >
                            ৳22
                          </span>
                        </li>
                        <li
                          data-v-bc96a3bc
                          className="rouletteMain_box_part_list"
                        >
                          <div
                            data-v-bc96a3bc
                            className="rouletteMain_box_part_color"
                          />
                          <span
                            data-v-bc96a3bc
                            className="rouletteMain_box_part_award"
                          >
                            ৳33
                          </span>
                        </li>
                        <li
                          data-v-bc96a3bc
                          className="rouletteMain_box_part_list"
                        >
                          <div
                            data-v-bc96a3bc
                            className="rouletteMain_box_part_color"
                          />
                          <span
                            data-v-bc96a3bc
                            className="rouletteMain_box_part_award"
                          >
                            ৳88
                          </span>
                        </li>
                        <li
                          data-v-bc96a3bc
                          className="rouletteMain_box_part_list"
                        >
                          <div
                            data-v-bc96a3bc
                            className="rouletteMain_box_part_color"
                          />
                          <span
                            data-v-bc96a3bc
                            className="rouletteMain_box_part_award"
                          >
                            ৳222
                          </span>
                        </li>
                        <li
                          data-v-bc96a3bc
                          className="rouletteMain_box_part_list"
                        >
                          <div
                            data-v-bc96a3bc
                            className="rouletteMain_box_part_color"
                          />
                          <span
                            data-v-bc96a3bc
                            className="rouletteMain_box_part_award"
                          >
                            ৳666
                          </span>
                        </li>
                        <li
                          data-v-bc96a3bc
                          className="rouletteMain_box_part_list"
                        >
                          <div
                            data-v-bc96a3bc
                            className="rouletteMain_box_part_color"
                          />
                          <span
                            data-v-bc96a3bc
                            className="rouletteMain_box_part_award"
                          >
                            ৳888
                          </span>
                        </li>
                        <li
                          data-v-bc96a3bc
                          className="rouletteMain_box_part_list"
                        >
                          <div
                            data-v-bc96a3bc
                            className="rouletteMain_box_part_color"
                          />
                          <span
                            data-v-bc96a3bc
                            className="rouletteMain_box_part_award"
                          >
                            ৳1111
                          </span>
                        </li>
                      </ul>
                      <div data-v-bc96a3bc className="rouletteMain_box_coin">
                        <span
                          data-v-bc96a3bc
                          className="rouletteMain_box_coinWrap"
                        >
                          <img
                            data-v-bc96a3bc
                            src="/assets/new/1.webp"
                            className="rouletteMain_box_coin_1"
                          />
                        </span>
                        <span
                          data-v-bc96a3bc
                          className="rouletteMain_box_coinWrap"
                        >
                          <img
                            data-v-bc96a3bc
                            src="/assets/new/2.webp"
                            className="rouletteMain_box_coin_2"
                          />
                        </span>
                        <span
                          data-v-bc96a3bc
                          className="rouletteMain_box_coinWrap"
                        >
                          <img
                            data-v-bc96a3bc
                            src="/assets/new/3.webp"
                            className="rouletteMain_box_coin_3"
                          />
                        </span>
                        <span
                          data-v-bc96a3bc
                          className="rouletteMain_box_coinWrap"
                        >
                          <img
                            data-v-bc96a3bc
                            src="/assets/new/4.webp"
                            className="rouletteMain_box_coin_4"
                          />
                        </span>
                        <span
                          data-v-bc96a3bc
                          className="rouletteMain_box_coinWrap"
                        >
                          <img
                            data-v-bc96a3bc
                            src="/assets/new/5.webp"
                            className="rouletteMain_box_coin_5"
                          />
                        </span>
                        <span
                          data-v-bc96a3bc
                          className="rouletteMain_box_coinWrap"
                        >
                          <img
                            data-v-bc96a3bc
                            src="/assets/new/6.webp"
                            className="rouletteMain_box_coin_6"
                          />
                        </span>
                      </div>
                      <div
                        data-v-bc96a3bc
                        className="rouletteMain_box_btn"
                        style={{
                          "background-image":
                            'url("/assets/new/spinbutton.webp")',
                          "background-position": "center center",
                          "background-size": "cover",
                        }}
                      />
                      <div
                        data-v-bc96a3bc
                        className="rouletteMain_box_numberTimes"
                      >
                        <div data-v-bc96a3bc>
                          <div data-v-bc96a3bc>
                            <span data-v-bc96a3bc>0</span>
                            <span data-v-bc96a3bc>coins</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div data-v-bc96a3bc className="rouletteMain_winner">
                    <div data-v-bc96a3bc className="rouletteMain_winner_wrap">
                      <div
                        data-v-bc96a3bc
                        className="rouletteMain_winner_head winnerList"
                      >
                        <div
                          data-v-bc96a3bc
                          className="rouletteMain_winner_head_item"
                        >
                          Winner's list
                        </div>
                        <div
                          data-v-bc96a3bc
                          className="rouletteMain_winner_head_item"
                        >
                          Winning record
                        </div>
                        <div
                          data-v-bc96a3bc
                          className="rouletteMain_winner_head_cursor leftMost"
                        />
                      </div>
                      <div
                        data-v-bc96a3bc
                        className="rouletteMain_winner_slider"
                      >
                        <ul
                          data-v-bc96a3bc
                          className="rouletteMain_winner_list pl-0"
                        >
                          <li
                            data-v-bc96a3bc
                            className="rouletteMain_winner_item"
                          >
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_date"
                            >
                              2026-01-19
                            </span>
                            <span data-v-bc96a3bc>has***</span>
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_prize"
                            >
                              22.00
                            </span>
                          </li>
                          <li
                            data-v-bc96a3bc
                            className="rouletteMain_winner_item"
                          >
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_date"
                            >
                              2026-01-19
                            </span>
                            <span data-v-bc96a3bc>has***</span>
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_prize"
                            >
                              11.00
                            </span>
                          </li>
                          <li
                            data-v-bc96a3bc
                            className="rouletteMain_winner_item"
                          >
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_date"
                            >
                              2026-01-19
                            </span>
                            <span data-v-bc96a3bc>has***</span>
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_prize"
                            >
                              11.00
                            </span>
                          </li>
                          <li
                            data-v-bc96a3bc
                            className="rouletteMain_winner_item"
                          >
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_date"
                            >
                              2026-01-19
                            </span>
                            <span data-v-bc96a3bc>has***</span>
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_prize"
                            >
                              33.00
                            </span>
                          </li>
                          <li
                            data-v-bc96a3bc
                            className="rouletteMain_winner_item"
                          >
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_date"
                            >
                              2026-01-19
                            </span>
                            <span data-v-bc96a3bc>hak***</span>
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_prize"
                            >
                              11.00
                            </span>
                          </li>
                          <li
                            data-v-bc96a3bc
                            className="rouletteMain_winner_item"
                          >
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_date"
                            >
                              2026-01-19
                            </span>
                            <span data-v-bc96a3bc>01788*****</span>
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_prize"
                            >
                              11.00
                            </span>
                          </li>
                          <li
                            data-v-bc96a3bc
                            className="rouletteMain_winner_item"
                          >
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_date"
                            >
                              2026-01-19
                            </span>
                            <span data-v-bc96a3bc>mdrty*****</span>
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_prize"
                            >
                              22.00
                            </span>
                          </li>
                          <li
                            data-v-bc96a3bc
                            className="rouletteMain_winner_item"
                          >
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_date"
                            >
                              2026-01-19
                            </span>
                            <span data-v-bc96a3bc>akh***</span>
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_prize"
                            >
                              11.00
                            </span>
                          </li>
                          <li
                            data-v-bc96a3bc
                            className="rouletteMain_winner_item"
                          >
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_date"
                            >
                              2026-01-19
                            </span>
                            <span data-v-bc96a3bc>somo****</span>
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_prize"
                            >
                              11.00
                            </span>
                          </li>
                          <li
                            data-v-bc96a3bc
                            className="rouletteMain_winner_item"
                          >
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_date"
                            >
                              2026-01-19
                            </span>
                            <span data-v-bc96a3bc>01781*****</span>
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_prize"
                            >
                              11.00
                            </span>
                          </li>
                          <li
                            data-v-bc96a3bc
                            className="rouletteMain_winner_item"
                          >
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_date"
                            >
                              2026-01-19
                            </span>
                            <span data-v-bc96a3bc>01839*****</span>
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_prize"
                            >
                              11.00
                            </span>
                          </li>
                          <li
                            data-v-bc96a3bc
                            className="rouletteMain_winner_item"
                          >
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_date"
                            >
                              2026-01-19
                            </span>
                            <span data-v-bc96a3bc>rov***</span>
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_prize"
                            >
                              11.00
                            </span>
                          </li>
                          <li
                            data-v-bc96a3bc
                            className="rouletteMain_winner_item"
                          >
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_date"
                            >
                              2026-01-19
                            </span>
                            <span data-v-bc96a3bc>01853*****</span>
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_prize"
                            >
                              11.00
                            </span>
                          </li>
                          <li
                            data-v-bc96a3bc
                            className="rouletteMain_winner_item"
                          >
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_date"
                            >
                              2026-01-19
                            </span>
                            <span data-v-bc96a3bc>01729*****</span>
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_prize"
                            >
                              11.00
                            </span>
                          </li>
                          <li
                            data-v-bc96a3bc
                            className="rouletteMain_winner_item"
                          >
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_date"
                            >
                              2026-01-19
                            </span>
                            <span data-v-bc96a3bc>01729*****</span>
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_prize"
                            >
                              11.00
                            </span>
                          </li>
                          <li
                            data-v-bc96a3bc
                            className="rouletteMain_winner_item"
                          >
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_date"
                            >
                              2026-01-19
                            </span>
                            <span data-v-bc96a3bc>01611*****</span>
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_prize"
                            >
                              11.00
                            </span>
                          </li>
                          <li
                            data-v-bc96a3bc
                            className="rouletteMain_winner_item"
                          >
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_date"
                            >
                              2026-01-19
                            </span>
                            <span data-v-bc96a3bc>01729*****</span>
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_prize"
                            >
                              22.00
                            </span>
                          </li>
                          <li
                            data-v-bc96a3bc
                            className="rouletteMain_winner_item"
                          >
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_date"
                            >
                              2026-01-19
                            </span>
                            <span data-v-bc96a3bc>01622*****</span>
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_prize"
                            >
                              22.00
                            </span>
                          </li>
                          <li
                            data-v-bc96a3bc
                            className="rouletteMain_winner_item"
                          >
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_date"
                            >
                              2026-01-19
                            </span>
                            <span data-v-bc96a3bc>sdsu****</span>
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_prize"
                            >
                              11.00
                            </span>
                          </li>
                          <li
                            data-v-bc96a3bc
                            className="rouletteMain_winner_item"
                          >
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_date"
                            >
                              2026-01-19
                            </span>
                            <span data-v-bc96a3bc>milonc******</span>
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_prize"
                            >
                              11.00
                            </span>
                          </li>
                          <li
                            data-v-bc96a3bc
                            className="rouletteMain_winner_item"
                          >
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_date"
                            >
                              2026-01-19
                            </span>
                            <span data-v-bc96a3bc>skshi*****</span>
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_prize"
                            >
                              22.00
                            </span>
                          </li>
                          <li
                            data-v-bc96a3bc
                            className="rouletteMain_winner_item"
                          >
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_date"
                            >
                              2026-01-19
                            </span>
                            <span data-v-bc96a3bc>30mo****</span>
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_prize"
                            >
                              11.00
                            </span>
                          </li>
                          <li
                            data-v-bc96a3bc
                            className="rouletteMain_winner_item"
                          >
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_date"
                            >
                              2026-01-19
                            </span>
                            <span data-v-bc96a3bc>mdro****</span>
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_prize"
                            >
                              22.00
                            </span>
                          </li>
                          <li
                            data-v-bc96a3bc
                            className="rouletteMain_winner_item"
                          >
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_date"
                            >
                              2026-01-19
                            </span>
                            <span data-v-bc96a3bc>019***</span>
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_prize"
                            >
                              11.00
                            </span>
                          </li>
                          <li
                            data-v-bc96a3bc
                            className="rouletteMain_winner_item"
                          >
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_date"
                            >
                              2026-01-19
                            </span>
                            <span data-v-bc96a3bc>abu***</span>
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_prize"
                            >
                              33.00
                            </span>
                          </li>
                          <li
                            data-v-bc96a3bc
                            className="rouletteMain_winner_item"
                          >
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_date"
                            >
                              2026-01-19
                            </span>
                            <span data-v-bc96a3bc>faru****</span>
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_prize"
                            >
                              22.00
                            </span>
                          </li>
                          <li
                            data-v-bc96a3bc
                            className="rouletteMain_winner_item"
                          >
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_date"
                            >
                              2026-01-19
                            </span>
                            <span data-v-bc96a3bc>01978*****</span>
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_prize"
                            >
                              11.00
                            </span>
                          </li>
                          <li
                            data-v-bc96a3bc
                            className="rouletteMain_winner_item"
                          >
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_date"
                            >
                              2026-01-19
                            </span>
                            <span data-v-bc96a3bc>2222j*****</span>
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_prize"
                            >
                              11.00
                            </span>
                          </li>
                          <li
                            data-v-bc96a3bc
                            className="rouletteMain_winner_item"
                          >
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_date"
                            >
                              2026-01-19
                            </span>
                            <span data-v-bc96a3bc>mds***</span>
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_prize"
                            >
                              11.00
                            </span>
                          </li>
                          <li
                            data-v-bc96a3bc
                            className="rouletteMain_winner_item"
                          >
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_date"
                            >
                              2026-01-19
                            </span>
                            <span data-v-bc96a3bc>noru****</span>
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_prize"
                            >
                              11.00
                            </span>
                          </li>
                          <li
                            data-v-bc96a3bc
                            className="rouletteMain_winner_item"
                          >
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_date"
                            >
                              2026-01-19
                            </span>
                            <span data-v-bc96a3bc>01788*****</span>
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_prize"
                            >
                              11.00
                            </span>
                          </li>
                          <li
                            data-v-bc96a3bc
                            className="rouletteMain_winner_item"
                          >
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_date"
                            >
                              2026-01-19
                            </span>
                            <span data-v-bc96a3bc>01788*****</span>
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_prize"
                            >
                              11.00
                            </span>
                          </li>
                          <li
                            data-v-bc96a3bc
                            className="rouletteMain_winner_item"
                          >
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_date"
                            >
                              2026-01-19
                            </span>
                            <span data-v-bc96a3bc>noru****</span>
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_prize"
                            >
                              11.00
                            </span>
                          </li>
                          <li
                            data-v-bc96a3bc
                            className="rouletteMain_winner_item"
                          >
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_date"
                            >
                              2026-01-19
                            </span>
                            <span data-v-bc96a3bc>noru****</span>
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_prize"
                            >
                              22.00
                            </span>
                          </li>
                          <li
                            data-v-bc96a3bc
                            className="rouletteMain_winner_item"
                          >
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_date"
                            >
                              2026-01-19
                            </span>
                            <span data-v-bc96a3bc>mdalam******</span>
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_prize"
                            >
                              11.00
                            </span>
                          </li>
                          <li
                            data-v-bc96a3bc
                            className="rouletteMain_winner_item"
                          >
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_date"
                            >
                              2026-01-19
                            </span>
                            <span data-v-bc96a3bc>01772*****</span>
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_prize"
                            >
                              22.00
                            </span>
                          </li>
                          <li
                            data-v-bc96a3bc
                            className="rouletteMain_winner_item"
                          >
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_date"
                            >
                              2026-01-19
                            </span>
                            <span data-v-bc96a3bc>rakib*****</span>
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_prize"
                            >
                              11.00
                            </span>
                          </li>
                          <li
                            data-v-bc96a3bc
                            className="rouletteMain_winner_item"
                          >
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_date"
                            >
                              2026-01-19
                            </span>
                            <span data-v-bc96a3bc>biall*****</span>
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_prize"
                            >
                              11.00
                            </span>
                          </li>
                          <li
                            data-v-bc96a3bc
                            className="rouletteMain_winner_item"
                          >
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_date"
                            >
                              2026-01-19
                            </span>
                            <span data-v-bc96a3bc>rov***</span>
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_prize"
                            >
                              11.00
                            </span>
                          </li>
                          <li
                            data-v-bc96a3bc
                            className="rouletteMain_winner_item"
                          >
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_date"
                            >
                              2026-01-19
                            </span>
                            <span data-v-bc96a3bc>mdnur*****</span>
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_prize"
                            >
                              11.00
                            </span>
                          </li>
                          <li
                            data-v-bc96a3bc
                            className="rouletteMain_winner_item"
                          >
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_date"
                            >
                              2026-01-19
                            </span>
                            <span data-v-bc96a3bc>mdra****</span>
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_prize"
                            >
                              11.00
                            </span>
                          </li>
                          <li
                            data-v-bc96a3bc
                            className="rouletteMain_winner_item"
                          >
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_date"
                            >
                              2026-01-19
                            </span>
                            <span data-v-bc96a3bc>mdra****</span>
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_prize"
                            >
                              11.00
                            </span>
                          </li>
                          <li
                            data-v-bc96a3bc
                            className="rouletteMain_winner_item"
                          >
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_date"
                            >
                              2026-01-19
                            </span>
                            <span data-v-bc96a3bc>masu****</span>
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_prize"
                            >
                              11.00
                            </span>
                          </li>
                          <li
                            data-v-bc96a3bc
                            className="rouletteMain_winner_item"
                          >
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_date"
                            >
                              2026-01-19
                            </span>
                            <span data-v-bc96a3bc>masu****</span>
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_prize"
                            >
                              22.00
                            </span>
                          </li>
                          <li
                            data-v-bc96a3bc
                            className="rouletteMain_winner_item"
                          >
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_date"
                            >
                              2026-01-19
                            </span>
                            <span data-v-bc96a3bc>mdrub*****</span>
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_prize"
                            >
                              11.00
                            </span>
                          </li>
                          <li
                            data-v-bc96a3bc
                            className="rouletteMain_winner_item"
                          >
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_date"
                            >
                              2026-01-19
                            </span>
                            <span data-v-bc96a3bc>aass****</span>
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_prize"
                            >
                              11.00
                            </span>
                          </li>
                          <li
                            data-v-bc96a3bc
                            className="rouletteMain_winner_item"
                          >
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_date"
                            >
                              2026-01-19
                            </span>
                            <span data-v-bc96a3bc>somo****</span>
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_prize"
                            >
                              11.00
                            </span>
                          </li>
                          <li
                            data-v-bc96a3bc
                            className="rouletteMain_winner_item"
                          >
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_date"
                            >
                              2026-01-19
                            </span>
                            <span data-v-bc96a3bc>01839*****</span>
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_prize"
                            >
                              11.00
                            </span>
                          </li>
                          <li
                            data-v-bc96a3bc
                            className="rouletteMain_winner_item"
                          >
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_date"
                            >
                              2026-01-19
                            </span>
                            <span data-v-bc96a3bc>amiru*****</span>
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_prize"
                            >
                              11.00
                            </span>
                          </li>
                          <li
                            data-v-bc96a3bc
                            className="rouletteMain_winner_item"
                          >
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_date"
                            >
                              2026-01-19
                            </span>
                            <span data-v-bc96a3bc>swap****</span>
                            <span
                              data-v-bc96a3bc
                              className="rouletteMain_winner_prize"
                            >
                              55.00
                            </span>
                          </li>
                        </ul>
                        <ul
                          data-v-bc96a3bc
                          className="rouletteMain_winner_list pl-0"
                          style={{ display: "none" }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              data-v-bc96a3bc
              style={{
                "-webkit-box-pack": "center",
                "-webkit-justify-content": "center",
                "-ms-flex-pack": "center",
                "justify-content": "center",
                display: "flex",
                "-webkit-align-items": "center",
                "-webkit-box-align": "center",
                "-ms-flex-align": "center",
                "align-items": "center",
                "margin-bottom": "20px",
                "margin-top": "-30px",
                gap: "20px",
                position: "relative",
                "z-index": "2",
              }}
            >
              <button
                data-v-bc96a3bc
                style={{
                  "background-color": "transparent",
                  border: "none",
                  position: "relative",
                }}
              >
                <img
                  data-v-bc96a3bc
                  src="/assets/new/RightBtn.webp"
                  width={30}
                  height={40}
                  style={{
                    "-webkit-transform": "scaleX(-1)",
                    "-ms-transform": "scaleX(-1)",
                    transform: "scaleX(-1)",
                    "background-color": "transparent",
                  }}
                />
              </button>
              <button
                data-v-bc96a3bc
                className="luckywheelbtn active"
                style={{
                  "-webkit-transform": "scale(1.1)",
                  "-ms-transform": "scale(1.1)",
                  transform: "scale(1.1)",
                }}
              />
              <button data-v-bc96a3bc className="luckywheelEx1btn" />
              <button data-v-bc96a3bc className="luckywheelEx2btn" />
              <button
                data-v-bc96a3bc
                style={{
                  "background-color": "transparent",
                  border: "none",
                  position: "relative",
                }}
              >
                <img
                  data-v-bc96a3bc
                  src="/assets/new/RightBtn.webp"
                  width={30}
                  height={40}
                  style={{ "background-color": "transparent" }}
                />
              </button>
            </div>
          </div>
          <div data-v-bc96a3bc className="rouletteRule">
            <div data-v-bc96a3bc className="rouletteRule_wrap">
              <h3 data-v-bc96a3bc className="rouletteRule_title">
                Terms &amp; Conditions:{" "}
              </h3>
              <p data-v-bc96a3bc className="rouletteRule_text" />
              <p data-v-bc96a3bc>
                <strong data-v-bc96a3bc>
                  <span data-v-bc96a3bc style={{ "font-size": "14px" }}>
                    Babu88 LUCKY WHEEL
                  </span>
                </strong>
              </p>
              <p data-v-bc96a3bc>
                <strong data-v-bc96a3bc>
                  <span data-v-bc96a3bc style={{ "font-size": "14px" }}>
                    Spin Lucky Wheel to get extra CASH!
                  </span>
                </strong>
              </p>
              <p data-v-bc96a3bc />
              <div data-v-bc96a3bc className="luckyWheel-divWrapper">
                <div
                  data-v-bc96a3bc
                  className="luckyWheelDetail-card v-card v-sheet v-sheet--outlined theme--light"
                >
                  <div data-v-bc96a3bc className="row row-border no-gutters">
                    <div data-v-bc96a3bc className="col-border col col-8">
                      <span data-v-bc96a3bc>Member Types</span>
                    </div>
                    <div data-v-bc96a3bc className="col-padding col col-4">
                      <span data-v-bc96a3bc>All Members</span>
                    </div>
                  </div>
                  <div data-v-bc96a3bc className="row row-border no-gutters">
                    <div data-v-bc96a3bc className="col-border col col-8">
                      <span data-v-bc96a3bc>Frequency</span>
                    </div>
                    <div data-v-bc96a3bc className="col-padding col col-4">
                      <span data-v-bc96a3bc>UNLIMITED</span>
                    </div>
                  </div>
                  <div data-v-bc96a3bc className="row row-border no-gutters">
                    <div data-v-bc96a3bc className="col-border col col-8">
                      <span data-v-bc96a3bc>Bonus / Rebate Percentage</span>
                    </div>
                    <div data-v-bc96a3bc className="col-padding col col-4">
                      <span data-v-bc96a3bc>N/A</span>
                    </div>
                  </div>
                  <div data-v-bc96a3bc className="row row-border no-gutters">
                    <div data-v-bc96a3bc className="col-border col col-8">
                      <span data-v-bc96a3bc>Max Bonus / Rebate</span>
                    </div>
                    <div data-v-bc96a3bc className="col-padding col col-4">
                      <span data-v-bc96a3bc>৳999</span>
                    </div>
                  </div>
                  <div data-v-bc96a3bc className="row row-border no-gutters">
                    <div data-v-bc96a3bc className="col-border col col-8">
                      <span data-v-bc96a3bc>Game Providers</span>
                    </div>
                    <div data-v-bc96a3bc className="col-padding col col-4">
                      <span data-v-bc96a3bc>All Game Providers</span>
                    </div>
                  </div>
                  <div data-v-bc96a3bc className="row row-border no-gutters">
                    <div data-v-bc96a3bc className="col-border col col-8">
                      <span data-v-bc96a3bc>Turnover Requirement</span>
                    </div>
                    <div data-v-bc96a3bc className="col-padding col col-4">
                      <span data-v-bc96a3bc>x1</span>
                    </div>
                  </div>
                </div>
              </div>
              <p data-v-bc96a3bc>
                <strong data-v-bc96a3bc>
                  <span data-v-bc96a3bc style={{ "font-size": "14px" }}>
                    How to get coins :
                  </span>
                </strong>
              </p>
              <p data-v-bc96a3bc>
                1. Make a minimum deposit of ৳200. Every ৳100 you deposited get
                1 coin. Example: If you deposit ৳1000, you will get 10 coins
              </p>
              <p data-v-bc96a3bc>
                <span data-v-bc96a3bc style={{ "font-size": "14px" }}>
                  2. Daily check in , check in everyday and get coins for free.
                </span>
              </p>
              <p data-v-bc96a3bc />
              <p data-v-bc96a3bc>
                <strong data-v-bc96a3bc>
                  <span data-v-bc96a3bc style={{ "font-size": "14px" }}>
                    Bonus Conditions:
                  </span>
                </strong>
              </p>
              <p data-v-bc96a3bc>
                <span data-v-bc96a3bc style={{ "font-size": "14px" }}>
                  1. This promotion is applicable to All Game Providers.
                </span>
              </p>
              <p data-v-bc96a3bc>
                <span data-v-bc96a3bc style={{ "font-size": "14px" }}>
                  2. There is no limitation how many times members can spin.
                </span>
              </p>
              <p data-v-bc96a3bc>
                <span data-v-bc96a3bc style={{ "font-size": "14px" }}>
                  3. Members are required to fulfill a turnover amount x1 bonus
                  amount in order to transfer or withdraw.
                </span>
              </p>
              <p data-v-bc96a3bc />
              <p data-v-bc96a3bc>
                <strong data-v-bc96a3bc>
                  <span data-v-bc96a3bc style={{ "font-size": "14px" }}>
                    Coins per spin:
                  </span>
                </strong>
              </p>
              <div data-v-bc96a3bc className="luckyWheel-divWrapper">
                <div
                  data-v-bc96a3bc
                  className="luckyWheelDetail-card v-card v-sheet v-sheet--outlined theme--light"
                >
                  <div data-v-bc96a3bc className="row row-border no-gutters">
                    <div data-v-bc96a3bc className="col-border col col-4">
                      <span data-v-bc96a3bc>Wheel of Bronze</span>
                    </div>
                    <div data-v-bc96a3bc className="col-padding col col-4">
                      <span data-v-bc96a3bc>Wheel of Silver</span>
                    </div>
                    <div data-v-bc96a3bc className="col-padding col col-4">
                      <span data-v-bc96a3bc>Wheel of Gold</span>
                    </div>
                  </div>
                  <div data-v-bc96a3bc className="row row-border no-gutters">
                    <div data-v-bc96a3bc className="col-border col col-4">
                      <span data-v-bc96a3bc>20 coins</span>
                    </div>
                    <div data-v-bc96a3bc className="col-padding col col-4">
                      <span data-v-bc96a3bc>60 coins</span>
                    </div>
                    <div data-v-bc96a3bc className="col-padding col col-4">
                      <span data-v-bc96a3bc>500 coins</span>
                    </div>
                  </div>
                </div>
              </div>
              <p data-v-bc96a3bc />
              <div data-v-bc96a3bc className="luckyWheel-divWrapper">
                <div
                  data-v-bc96a3bc
                  className="luckyWheelDetail-card v-card v-sheet v-sheet--outlined theme--light"
                >
                  <div data-v-bc96a3bc className="row row-border no-gutters">
                    <div data-v-bc96a3bc className="col-border col col-4">
                      <span data-v-bc96a3bc>Wheel of Bronze</span>
                    </div>
                    <div data-v-bc96a3bc className="col-padding col col-4">
                      <span data-v-bc96a3bc>Wheel of Silver</span>
                    </div>
                    <div data-v-bc96a3bc className="col-padding col col-4">
                      <span data-v-bc96a3bc>Wheel of Gold</span>
                    </div>
                  </div>
                  <div data-v-bc96a3bc className="row row-border no-gutters">
                    <div data-v-bc96a3bc className="col-border col col-4">
                      <span data-v-bc96a3bc>৳1111</span>
                    </div>
                    <div data-v-bc96a3bc className="col-padding col col-4">
                      <span data-v-bc96a3bc>৳5555</span>
                    </div>
                    <div data-v-bc96a3bc className="col-padding col col-4">
                      <span data-v-bc96a3bc>৳88888</span>
                    </div>
                  </div>
                  <div data-v-bc96a3bc className="row row-border no-gutters">
                    <div data-v-bc96a3bc className="col-border col col-4">
                      <span data-v-bc96a3bc>৳888</span>
                    </div>
                    <div data-v-bc96a3bc className="col-padding col col-4">
                      <span data-v-bc96a3bc>৳1222</span>
                    </div>
                    <div data-v-bc96a3bc className="col-padding col col-4">
                      <span data-v-bc96a3bc>৳18888</span>
                    </div>
                  </div>
                  <div data-v-bc96a3bc className="row row-border no-gutters">
                    <div data-v-bc96a3bc className="col-border col col-4">
                      <span data-v-bc96a3bc>৳666</span>
                    </div>
                    <div data-v-bc96a3bc className="col-padding col col-4">
                      <span data-v-bc96a3bc>৳777</span>
                    </div>
                    <div data-v-bc96a3bc className="col-padding col col-4">
                      <span data-v-bc96a3bc>৳8888</span>
                    </div>
                  </div>
                  <div data-v-bc96a3bc className="row row-border no-gutters">
                    <div data-v-bc96a3bc className="col-border col col-4">
                      <span data-v-bc96a3bc>৳222</span>
                    </div>
                    <div data-v-bc96a3bc className="col-padding col col-4">
                      <span data-v-bc96a3bc>৳444</span>
                    </div>
                    <div data-v-bc96a3bc className="col-padding col col-4">
                      <span data-v-bc96a3bc>৳3888</span>
                    </div>
                  </div>
                  <div data-v-bc96a3bc className="row row-border no-gutters">
                    <div data-v-bc96a3bc className="col-border col col-4">
                      <span data-v-bc96a3bc>৳88</span>
                    </div>
                    <div data-v-bc96a3bc className="col-padding col col-4">
                      <span data-v-bc96a3bc>৳222</span>
                    </div>
                    <div data-v-bc96a3bc className="col-padding col col-4">
                      <span data-v-bc96a3bc>৳1888</span>
                    </div>
                  </div>
                  <div data-v-bc96a3bc className="row row-border no-gutters">
                    <div data-v-bc96a3bc className="col-border col col-4">
                      <span data-v-bc96a3bc>৳33</span>
                    </div>
                    <div data-v-bc96a3bc className="col-padding col col-4">
                      <span data-v-bc96a3bc>৳88</span>
                    </div>
                    <div data-v-bc96a3bc className="col-padding col col-4">
                      <span data-v-bc96a3bc>৳888</span>
                    </div>
                  </div>
                  <div data-v-bc96a3bc className="row row-border no-gutters">
                    <div data-v-bc96a3bc className="col-border col col-4">
                      <span data-v-bc96a3bc>৳22</span>
                    </div>
                    <div data-v-bc96a3bc className="col-padding col col-4">
                      <span data-v-bc96a3bc>৳55</span>
                    </div>
                    <div data-v-bc96a3bc className="col-padding col col-4">
                      <span data-v-bc96a3bc>৳444</span>
                    </div>
                  </div>
                  <div data-v-bc96a3bc className="row row-border no-gutters">
                    <div data-v-bc96a3bc className="col-border col col-4">
                      <span data-v-bc96a3bc>৳11</span>
                    </div>
                    <div data-v-bc96a3bc className="col-padding col col-4">
                      <span data-v-bc96a3bc>৳33</span>
                    </div>
                    <div data-v-bc96a3bc className="col-padding col col-4">
                      <span data-v-bc96a3bc>৳222</span>
                    </div>
                  </div>
                </div>
              </div>
              <p data-v-bc96a3bc />
              <p data-v-bc96a3bc>
                <strong data-v-bc96a3bc>
                  <span data-v-bc96a3bc style={{ "font-size": "14px" }}>
                    Terms &amp; Conditions:{" "}
                  </span>
                </strong>
              </p>
              <p data-v-bc96a3bc>
                <span data-v-bc96a3bc style={{ "font-size": "14px" }}>
                  1. All promotion offers are limited to only one per person.
                  Any shared or same household address, IP address, email
                  address, telephone number,credit or debit card and/or
                  e-payment account, or shared device (e.g. school, public
                  library or workplace) are not allowed.
                </span>
              </p>
              <p data-v-bc96a3bc>
                <span data-v-bc96a3bc style={{ "font-size": "14px" }}>
                  2. Members are not allowed to bet at the same time
                  (Banker/Player, Big/Small, Black/White, Single/Double, etc.) .
                </span>
              </p>
              <p data-v-bc96a3bc>
                <span data-v-bc96a3bc style={{ "font-size": "14px" }}>
                  3. Any bets resulting in void, tie, canceled, or made on
                  opposite sides with the same outcome will not be counted as a
                  valid turnover . Members are not allowed to bet at the same
                  time and roulette (black small/red large) or more than 18
                  numbers. Only 1/4 from your total bets will be counted as
                  turnover for bets made on Roulette.
                </span>
              </p>
              <p data-v-bc96a3bc>
                <span data-v-bc96a3bc style={{ "font-size": "14px" }}>
                  4. All bonuses are not allowed to be used to purchase FREE
                  GAMES, FREE SPINS or any similar type of feature. All bonus
                  funds, money won and deposited may be removed immediately if
                  member is suspected or caught.
                </span>
              </p>
              <p data-v-bc96a3bc>
                <span data-v-bc96a3bc style={{ "font-size": "14px" }}>
                  5. Participating members must accept and comply with all the
                  terms mentioned above as well as all relevant rules and
                  regulations stated on the babu99 app.
                </span>
              </p>
              <p data-v-bc96a3bc>
                <span data-v-bc96a3bc style={{ "font-size": "14px" }}>
                  6. babu99 reserves the right to freeze/block a members
                  account if suspected of any fraudulent or suspicious
                  activities.
                </span>
              </p>
              <p data-v-bc96a3bc>
                <span data-v-bc96a3bc style={{ "font-size": "14px" }}>
                  7. babu99 reserves the right to modify, cancel, suspend or
                  terminate the promotion and/or change the terms of the said
                  promotion at any time without prior notice.
                </span>
              </p>
              <p data-v-bc96a3bc>
                <strong data-v-bc96a3bc>
                  <span data-v-bc96a3bc style={{ "font-size": "14px" }}>
                    General Babu88 Terms &amp; Conditions apply.
                  </span>
                </strong>
              </p>
            </div>
          </div>
        </div>
      </div>{" "}
    </>
  );
};

export default SpinWeb;
